<template>
  <div class="pb-3">
    <section id="api_tasks_events" class="pt-2">
      <h4 class="pb-2">События задачи</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">GET</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}/:id/events</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>id</td>
                  <td>целое число</td>
                  <td>обязательный параметр</td>
                  <td>ID задачи</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -H "Authorization: Bearer {{ token }}" {{ url }}/{{ method }}/1/events</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success",
  "data": [
    {
      "content": "HTTP/1.1 200 OK\r\nServer: nginx\r\nDate: Sat, 21 Nov 2020 14:12:11 GMT\r\nContent-Type: text/html\r\nContent-Length: 22\r\nConnection: keep-alive\r\nX-Powered-By: PHP/7.3.17\r\nVary: Accept-Encoding,User-Agent\r\nContent-Encoding: gzip\r\n\r\nOK",
      "code": 200,
      "status": "up",
      "date": "2020-11-21 17:12:14",
      "id": 345
    },
    {
      "content": "Operation timed out after 10001 milliseconds with 0 bytes received",
      "code": 28,
      "status": "down",
      "date": "2020-11-21 17:10:25",
      "id": 344
    },
  ]
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/tasks'
      }
    }
  }
</script>